<template>
  <div class="title-container" :style="{borderColor: color}">
    <div class="title-text" :style="{color}">{{title}}</div>
    <span class="more" @click="goUrl">更多<i class="el-icon-arrow-right"></i></span>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    url: {
      type: [Object, String],
      default: () => { }
    },
    color: {
      type: String,
      default: "#212529"
    },
  },
  components: {

  },
  mounted() {

  },
  methods: {
    goUrl() {
      if (this.url) {
        this.$router.push(this.url)
      }
    }
  },
}
</script>

<style lang="less" scoped>
.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  border-bottom-width: 2px;
  border-bottom-style: solid;
  .title-text {
    font-size: 26px;
    font-weight: 600;
  }
  .more {
    font-size: 14px;
    color: #212529;
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
  .title-container {
    padding: 8px 0;
    border-bottom-width: 1px;
    .title-text {
      font-size: 18px;
      font-weight: 600;
    }
    .more {
      font-size: 12px;
      color: #212529;
      cursor: pointer;
    }
  }
}
</style>